(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/helpers/terms-integrity-handlebar-helper.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/helpers/terms-integrity-handlebar-helper.js'); 

(function() {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {

    hbs.registerHelper('convertSize', function(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) {
        return '';
      }
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) {
        return bytes + ' ' + sizes[i];
      }
      return (bytes / Math.pow(1024, i)).toFixed(0) + ' ' + sizes[i];
    });

    hbs.registerHelper('convertDate', function(date) {
      if (date === null) {
        return '';
      }
      date = date.substring(0, date.indexOf('T'));
      return date;
    });
  }
})();

 })(window);